import React from 'react';
import { InvoiceTemplateProps } from './types';
import Header from './primitives/Header';
import PatientInfo from './primitives/PatientInfo';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template3_SmallWithHeader({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div className="bg-white p-4 max-w-[80mm] mx-auto text-xs">
      <Header hospital={hospital} showLogo={true} variant="centered" title="CASH MEMO / BILL" />

      <PatientInfo invoice={invoice} layout="compact" />
      
      <ItemsTable items={invoice.items} variant="compact" headerColor="bg-blue-600" />
      
      <Totals invoice={invoice} layout="compact" showPaymentInfo={true} />
      
      <Footer variant="minimal" />
    </div>
  );
}
